export const LAYOUT = {
  stackSection: 3,
  stackComfortable: 2.5,
  stackTight: 2,
  stackDense: 1.5,
  cardPadding: { xs: 2, sm: 2.5 } as const,
  cardPaddingLg: { xs: 2.5, sm: 3 } as const,
  cardPaddingDense: 2,
  gridSpacing: 2,
  gridSpacingLoose: 2.5,
  pageMaxWidth: 1320,
  formMaxWidth: 900,
  detailMaxWidth: 1000,
  breadcrumbsGap: 1.5,
  headerMarginBottom: 3,
  titleBlockGap: 2,
  tableFooterPadding: { px: 2, py: 1.25 },
  inlineIconGap: 1,
  contentPadding: { xs: 2, sm: 3, md: 4 } as const,
  stackSurfaceGap: 3,
} as const;
